//BFSG
import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'

import useLazyImgSrc from 'hooks/useLazyImgSrc'
import { ReactComponent as LinkArrow } from 'assets/link-arrow.svg'
import usePersonalization from 'hooks/usePersonalization'
import { OptImg } from 'utils/imageOptimization'

type Props = {
  imgSrc: string | OptImg
  link: string
  title: string
  linkLabel: string
}

export default function ImageItem(props: Props) {
  const [ref, imgUrl] = useLazyImgSrc<HTMLImageElement>(props.imgSrc, 100)
  const personalization = usePersonalization()

  return (
    <ButtonWrapper
      data-cy-handle="category-item"
      onClick={() => personalization.trackClick()}
      $imgSrc={imgUrl}
    >
      <div ref={ref} className="ImageTeaser">
        <div className="teaser-image"></div>
        <div className="teaser-description">
          {props.title && (
            <div data-cy-state={'show-title'} className="title">
              {props.title}
            </div>
          )}
          <div className="label">
            {props.linkLabel} <LinkArrow />
          </div>
        </div>
      </div>
    </ButtonWrapper>
  )
}

const ButtonWrapper = styled.button<{ $imgSrc: string }>`
  width: 100%;
  cursor: pointer;
  > .ImageTeaser {
    display: grid;
    grid-template-rows: repeat(9, 1fr);

    @media (min-width: ${theme.ms.MD}px) {
      height: 15rem;
      grid-template-rows: 1fr;
    }
    @media (min-width: ${theme.ms.LG}px) {
      height: 26.875rem;
    }
    > .teaser-image {
      background-image: url('${(p) => p.$imgSrc}');
      display: block;
      background-size: cover;
      background-position: center center;
      width: 100%;
      grid-row: 1 / 8;
      grid-column: 1;
      height: 11.25rem;
      @media (min-width: ${theme.ms.MD}px) {
        height: 15rem;
      }
      @media (min-width: ${theme.ms.LG}px) {
        height: 26.875rem;
      }
    }

    > .teaser-description {
      background: ${theme.colors.white};
      border-radius: 15px 0px 15px 15px;
      border: 2px solid ${theme.colors.primary};
      margin-left: ${theme.spacing('xs')};
      margin-top: 10px;
      padding: ${theme.spacing('m')};
      grid-row: 6 / -1;
      grid-column: 1;
      width: fit-content;
      @media (min-width: ${theme.ms.MD}px) {
        margin-left: ${theme.spacing('m')};
        margin-bottom: ${theme.spacing('m')};
        max-width: 41.25rem;
      }
      > .title {
        ${theme.ty('rc-base')}
        margin-bottom: ${theme.spacing('xs')};
        @media (min-width: ${theme.ms.MD}px) {
          margin-bottom: ${theme.spacing('s')};
        }
        @media (min-width: ${theme.ms.LG}px) {
          ${theme.ty('rc-2xl')}
          margin-bottom: ${theme.spacing('s')};
        }
      }
      .label {
        ${theme.ty('r-s', 'bold')}
        @media (min-width: ${theme.ms.LG}px) {
          display: block;
          ${theme.ty('rc-base', 'bold')}
        }
        > svg {
          margin-bottom: -3px;
          g {
            filter: none;
          }
        }
      }
    }
  }
`

const Wrapper = styled.div<{ $imgSrc: string }>``
